import { AST } from "@/mk2/apps/wiki/schemas";
import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

///////////////////////////////////////////////////////////////////
// Reviews load

export const STROLLER_REVIEWS_FETCH_TRIGGER = "STROLLER_REVIEWS_FETCH_TRIGGER";
export interface StrollerReviewsFetchTriggerAction {
    readonly type: typeof STROLLER_REVIEWS_FETCH_TRIGGER;
    readonly strollerSlug: string;
}
export const STROLLER_REVIEWS_FETCH_REQUEST = "STROLLER_REVIEWS_FETCH_REQUEST";
export interface StrollerReviewsFetchRequestAction extends APIRequestAction {
    readonly type: typeof STROLLER_REVIEWS_FETCH_REQUEST;
    readonly strollerSlug: string;
}
export interface StrollerReviewsFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        stroller: number;
        descriptionAST: AST;
        strollerReviews: number[];
        strollerPendingReviews: number[];
        strollerAlikeStrollers: number[];
        strollerReviewsActiveProducts: number[];
    };
}
export const STROLLER_REVIEWS_FETCH_SUCCESS = "STROLLER_REVIEWS_FETCH_SUCCESS";
export interface StrollerReviewsFetchSuccessAction extends APISuccessAction<StrollerReviewsFetchNormalizedResponse> {
    readonly type: typeof STROLLER_REVIEWS_FETCH_SUCCESS;
    readonly strollerSlug: string;
}
export const STROLLER_REVIEWS_FETCH_FAILURE = "STROLLER_REVIEWS_FETCH_FAILURE";
export interface StrollerReviewsFetchFailureAction extends APIFailureAction {
    readonly type: typeof STROLLER_REVIEWS_FETCH_FAILURE;
    readonly strollerSlug: string;
}

export const strollerReviewsFetchTrigger = (
    strollerSlug: string,
): StrollerReviewsFetchTriggerAction => ({
    type: STROLLER_REVIEWS_FETCH_TRIGGER,
    strollerSlug,
});
export const strollerReviewsFetchApi = {
    request: (strollerSlug: string): StrollerReviewsFetchRequestAction => ({
        type: STROLLER_REVIEWS_FETCH_REQUEST,
        strollerSlug,
    }),
    success: (
        strollerSlug: string,
        response: StrollerReviewsFetchNormalizedResponse,
    ): StrollerReviewsFetchSuccessAction => ({
        type: STROLLER_REVIEWS_FETCH_SUCCESS,
        strollerSlug,
        response,
    }),
    failure: (strollerSlug: string, error: any): StrollerReviewsFetchFailureAction => ({
        type: STROLLER_REVIEWS_FETCH_FAILURE,
        strollerSlug,
        error,
    }),
};
